import React, { useContext } from 'react'
import SmallModal from '../../../components/Modals/SmallModal'
import { Button, ButtonGroup, Stack, Typography } from '@mui/material'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'
import { useNavigate } from 'react-router-dom'

const ArchiveLocationPopup = ({ open, onClose, locationID }) => {
  const { setToast } = useContext(GlobalContext)
  const navigate = useNavigate()
  const handleConfirmArchive = () => {
    API.post('/medsmx/archivelocation', {
      locationID,
    }).then((res) => {
      if (res.status === 200) {
        onClose()
        navigate('/medicines-management')
        setToast({ message: 'Medicine Location Archived' })
      } else {
        onClose()
        setToast({
          message: 'Unable to Archive Location. Please try again later.',
          severity: 'error',
        })
      }
    })
  }
  return (
    <SmallModal open={open} onClose={onClose}>
      <Stack gap={2}>
        <Typography textAlign='center'>Are you sure you want to Archive this Location?</Typography>
        <ButtonGroup orientation="vertical">
          <Button
            onClick={handleConfirmArchive}
            color="error"
            variant="contained"
            size="small"
          >
            Yes - Archive
          </Button>
          <Button
            onClick={onClose}
            color="error"
            variant="outlined"
            size="small"
          >
            Cancel
          </Button>
        </ButtonGroup>
      </Stack>
    </SmallModal>
  )
}

export default ArchiveLocationPopup
